import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import pure from 'recompose/pure';
import getHomePageConfig from './getHomePageConfig';

/* Component */
// import CategoryBanner from './CategoryBanner';
// import HostATasting from '../../_common/Footer/HostATasting/HostATasting';
// import FullWidthBanner from './_common/FullWidthBanner';
// import VideoPlayer from '../../_common/Video/VideoPlayer';
// import TwoButtonBanner from '../../_common/Banner/TwoButtonBanner';
// import NoImageBanner from '../../_common/Banner/noImageBanner';
// import OverlayImageBanner from '../../_common/Banner/overlayImageBanner';
// import HalfWidthImageBanner from '../../_common/Banner/HalfWidthImageBanner/HalfWidthImageBanner';
// import HalfImageHeroLeft from './HalfImageHeroLeft/HalfImageHeroLeft';
import HalfImageHeroRight from './HalfImageHeroRight/HalfImageHeroRight';
import HalfTextBoxHeroLeft from './HalfTextBoxHeroLeft/HalfTextBoxHeroLeft';
import HalfImageHeroLeftPromo from './HalfImageHeroLeftPromo/HalfImageHeroLeftPromo';
import TastingKitPromo from './TastingKit/TastingKitPromo';
import TastingKitSnackBar from './TastingKit/TastingKitSnackBar';
// import CenteredTextHero from '../../_common/Hero/CenteredTextHero/CenteredTextHero';
// import TextWithBorder from './_common/TextWithBorder';
// import DoubleTile from './DoubleTile/DoubleTile';
// import ImageHeaderBanner from './_common/ImageHeaderBanner';
// import GiftBanners from '../../_common/GiftBanners/GiftBanners';
// import DualImageBanner from '../../_common/Banner/dualImageBanner';
// import DualImageTextBanner from '../../_common/Banner/dualImageTextBanner';
// import Header from './Header';
// import CategorySection from './CategorySection';
// import ImpactToDateHero from './../../Layouts/StaticPages/ImpactPage/ImpactToDateHero';
// import VideoHero from '../../_common/Hero/VideoHero/VideoHero';
// import MediumBannerCenter from '../../_common/Banner/mediumCenterBanner';
import NewArrivalsGallery from '../../_common/ImageGallery/Galleries/NewArrivalsGallery';
import BestSellersGallery from '../../_common/ImageGallery/Galleries/BestSellersGallery';
import SingleImageBanner from '../../_common/Banner/singleImageBanner';
import TextBanner from './TextBanner/TextBanner';
import TextImageBanner from '../../_common/TextImageBanner/TextImageBanner';
import PromoSnackBar from './PromoSnackBar';
import DynamicTile from '../../_common/DynamicTile/DynamicTile';
import FeatureHighlight from './FeatureHighlight';
/* Mutations */

/* Utils */
import { trackEvent } from '../../../utils/tracking';
/* Style */
import './HomePage.scss';

class HomePage extends Component {
  static propTypes = {
    // viewer: PropTypes.object.isRequired,
    // relay: PropTypes.object.isRequired,
    cartNavOpen: PropTypes.bool.isRequired,
    handleRouteChange: PropTypes.func.isRequired,
    containerWidth: PropTypes.number.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  onProductClick = (e, slug) => {
    e.preventDefault();
    this.context.router.push(`/shop/product/${slug}`);
  };

  onPromotionClick = (e, promotionId, position, name) => {
    e.preventDefault();
    const { viewer: user } = this.props;
    trackEvent({
      user,
      event: 'Promotion Clicked',
      properties: {
        name,
        position,
        promotionId,
      },
    });
  };

  getSlidesToShow = () => {
    const { containerWidth } = this.props;
    switch (true) {
      case containerWidth < 600:
        return 1;
      case containerWidth < 1000:
        return 1;
      case containerWidth < 1200:
        return 3;
      default:
        return 3;
    }
  };

  getComponent = (type, el) => {
    if (this.props.viewer) {
      const {
        containerWidth,
        handleRouteChange,
        cartNavOpen,
        viewer,
        shopNavOpen,
        handleAuthentication,
        relay: { environment },
      } = this.props;
      const category = 'wine';
      const isLoggedIn = viewer && viewer.isLoggedIn;
      const user = viewer && viewer.user;
      const permissions = user && user.permissions;
      const conciergeUser = user && user.conciergeUser;
      const preferredCustomerAccess = conciergeUser
        ? conciergeUser.permissions &&
          conciergeUser.permissions.oneCommerce &&
          conciergeUser.permissions.oneCommerce.preferredCustomer &&
          conciergeUser.permissions.oneCommerce.preferredCustomer.access
        : permissions &&
          permissions.oneCommerce &&
          permissions.oneCommerce.preferredCustomer &&
          permissions.oneCommerce.preferredCustomer.access;
      const isPreferredCustomer = !!preferredCustomerAccess;

      const userId =
        (user && user.conciergeCustomerAccountId) || (user && user.userId);

      const slidesToShow = this.getSlidesToShow();
      switch (type) {
        case 'tastingKit':
          return <TastingKitPromo user={user} config={el} />;
        case 'tastingKitSnackBar':
          return <TastingKitSnackBar user={user} config={el} />;
        case 'promotionsSnackBar':
          return (
            <PromoSnackBar config={el} handleRouteChange={handleRouteChange} />
          );
        case 'halfTextBoxHeroLeft':
          return (
            <HalfTextBoxHeroLeft
              config={el}
              isLoggedIn={isLoggedIn}
              isPreferredCustomer={isPreferredCustomer}
              containerWidth={containerWidth}
              handleRouteChange={handleRouteChange}
            />
          );
        case 'halfImageHeroLeftPromo':
          return (
            <HalfImageHeroLeftPromo
              config={el}
              isLoggedIn={isLoggedIn}
              handleRouteChange={handleRouteChange}
              containerWidth={containerWidth}
            />
          );
        case 'halfImageHeroRight':
          return (
            <HalfImageHeroRight
              config={el}
              containerWidth={containerWidth}
              handleRouteChange={handleRouteChange}
            />
          );
        case 'dynamicTile':
          return (
            <DynamicTile config={el} handleRouteChange={handleRouteChange} />
          );
        case 'imageGallery':
          switch (el.galleryId) {
            case 'newArrivals':
              return (
                <NewArrivalsGallery
                  showSlider
                  accountId={userId}
                  slidesToShow={slidesToShow}
                  galleryTitle={el.galleryTitle}
                  newCategory={el.newCategory}
                  headerUrl={el.headerUrl}
                  addToCart={this.props.addToCart}
                  {...{
                    user,
                    environment,
                    category,
                    shopNavOpen,
                    cartNavOpen,
                    containerWidth,
                    handleRouteChange,
                    handleAuthentication,
                    onProductClick: this.onProductClick,
                  }}
                />
              );
            default:
              return (
                <BestSellersGallery
                  showSlider
                  accountId={userId}
                  slidesToShow={slidesToShow}
                  galleryTitle={el.galleryTitle}
                  newCategory={el.newCategory}
                  addToCart={this.props.addToCart}
                  headerUrl={el.headerUrl}
                  {...{
                    user,
                    environment,
                    category,
                    shopNavOpen,
                    cartNavOpen,
                    containerWidth,
                    handleRouteChange,
                    handleAuthentication,
                    onProductClick: this.onProductClick,
                  }}
                />
              );
          }
        case 'singleImageBanner':
          return (
            <SingleImageBanner
              imgSrc={el.imgSrc}
              imgWidth={el.imgWidth}
              imgHeight={el.imgHeight}
              imgSrcTablet={el.imgSrcTablet}
              imgWidthTablet={el.imgWidthTablet}
              imgHeightTablet={el.imgHeightTablet}
              imgSrcMobile={el.imgSrcMobile}
              imgWidthMobile={el.imgWidthMobile}
              imgHeightMobile={el.imgHeightMobile}
              imgAlt={el.imgAlt}
              imgLink={el.imgLink}
              linkCategory={el.linkCategory}
              backgroundColor={el.backgroundColor}
              containerWidth={containerWidth}
              handleRouteChange={handleRouteChange}
            />
          );
        case 'textImageBanner':
          return <TextImageBanner config={el} />;
        case 'textBanner':
          return (
            <TextBanner
              config={el}
              isLoggedIn={isLoggedIn}
              containerWidth={containerWidth}
              handleRouteChange={handleRouteChange}
            />
          );
        case 'featureHighlight':
          return (
            <FeatureHighlight
              config={el}
              handleRouteChange={handleRouteChange}
            />
          );
        default:
          return null;
      }
    }
  };

  render() {
    const configToUse = getHomePageConfig();
    return (
      <div className="HomePage">
        {configToUse.map(el => (
          <div key={el.key}>{el.enabled && this.getComponent(el.type, el)}</div>
        ))}
      </div>
    );
  }
}

export default createRefetchContainer(
  pure(HomePage),
  {
    viewer: graphql`
      fragment HomePage_viewer on Viewer {
        id
        isLoggedIn
        user {
          id
          userId
          conciergeCustomerAccountId
          segmentPersonas {
            prospects
          }
          availableTastingFlightCode {
            code
            expiresOn
          }
          conciergeUser {
            userId
            permissions {
              id
              oneCommerce {
                id
                preferredCustomer {
                  access
                }
              }
            }
          }
          permissions {
            id
            oneCommerce {
              id
              ceo {
                access
              }
              preferredCustomer {
                access
              }
            }
          }
          email
          role
        }
      }
    `,
  },
  graphql`
    query HomePageRefetchQuery {
      viewer {
        id
        ...HomePage_viewer
      }
    }
  `,
);
